import { useSelector } from '@grandvisionhq/state';
import '../../../../../models/cart/cart-state.js';
import '../../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../../models/step-shipping/shipping-methods.js';
import '../../../../../models/shared.js';
import { getSelectedPickupPoint, getSelectedStore } from '../../../../../StepShipping/selectors.js';
import { mapGVShippingMethodToApplePayShippingType } from '../mappers/apple-pay-shipping-types.js';
import { mapPickupPointToApplePayShippingContact } from '../mappers/pickup-point-to-apple-shipping-contact.js';
import { mapStoreToApplePayShippingContact } from '../mappers/store-to-apple-shipping-contact.js';

var ShippingContactEditingMode;
(function(ShippingContactEditingMode) {
    ShippingContactEditingMode["STORE_PICKUP"] = 'storePickup';
    ShippingContactEditingMode["DEFAULT"] = 'enabled';
})(ShippingContactEditingMode || (ShippingContactEditingMode = {}));
const useMapShippingContact = (cart)=>{
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const selectedServiceStore = useSelector(getSelectedStore);
    const shippingMethod = cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key;
    const isPickupPointSelected = shippingMethod === ShippingMethod.PickupPoint && !!selectedPickupPoint;
    const isStorePickUpSelected = shippingMethod === ShippingMethod.Pickup && !!selectedServiceStore;
    let shippingContact;
    if (isPickupPointSelected) {
        shippingContact = mapPickupPointToApplePayShippingContact(selectedPickupPoint);
    }
    if (isStorePickUpSelected) {
        shippingContact = mapStoreToApplePayShippingContact(selectedServiceStore);
    }
    return {
        shippingContact,
        shippingContactEditingMode: isPickupPointSelected || isStorePickUpSelected ? ShippingContactEditingMode.STORE_PICKUP : ShippingContactEditingMode.DEFAULT,
        shippingType: mapGVShippingMethodToApplePayShippingType(shippingMethod)
    };
};

export { ShippingContactEditingMode, useMapShippingContact };
//# sourceMappingURL=use-map-shipping-contact.js.map
